import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { EligibilityStatusService } from 'application/eligibility-status/services';
import { action, observable } from 'mobx';

class FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore extends BaseEditViewStore {
    @observable accessor eligibilityStatus;
    constructor(rootStore, componentProps) {
        const facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'facility-order-template-activate-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalForm,
            id: facilityOrderPatient.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        return {
                            ...facilityOrderPatient
                        };
                    },
                    update: async (resource) => {
                        await facilityOrderTemplateService.activateFacilityOrderTemplate(resource);
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalForm,
            autoInit: false
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
        this.facilityOrderPatient = facilityOrderPatient;
        this.patient = this.modalParams.data.patient;
        this.fetchPatientTemplates = this.modalParams.data.fetchPatientTemplates;
        this.setPatientStatus = this.modalParams.data.setPatientStatus;
        this.eligibilityStatusService = new EligibilityStatusService(rootStore.application.baasic.apiClient);
        this.eligibilityStatusStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async (term) => {
                const response = await this.eligibilityStatusService.find({
                    searchQuery: term,
                    rpp: 50
                });
                return response.data.item;
            },
            onChange: () => {
                this.eligibilityStatus = this.eligibilityStatusStore.value && this.eligibilityStatusStore.value.name;
            }
        });
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.facilityOrderTemplate ? this.facilityOrderTemplate.id : null,
                facilityOrderPatientId: this.id,
                ...resource,
            });

            this.modalParams.close();

            await this.fetchPatientTemplates();

            if(this.setPatientStatus)
                await this.setPatientStatus();

            this.form.setFieldsDisabled(false);
       
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success( this.facilityOrderTemplate ? 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_US_INTAKE.TEMPLATE_ACTIVATION.SUCCESS_UPDATE' : 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_US_INTAKE.PATIENT_ACTIVATION.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalStore;